import store from "../store/store"

export const isMetricsEnabled = (): boolean => {
    const config = store.getState().config.config.data
    return config?.WebConfig?.appSettings?.metricsEnabled ?? false
}
